import { BaseApi as Base } from '@micromag/data';

class ContributionsApi extends Base {
    get(id, query = {}, page = 1, count = 10) {
        const finalQuery = {
            ...query,
        };
        if (page !== null) {
            finalQuery.page = page;
        }
        if (count !== null) {
            finalQuery.count = count;
        }
        return this.requestGet(this.route('api.contributions.show', { screen: id }), finalQuery);
    }

    create(data) {
        return this.requestPost(this.route('api.contributions.store'), data);
    }
}

export default ContributionsApi;
